import React from "react";
import classNames from "classnames";

import styles from "./ActionButton.module.scss";

interface ActionButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  className?: string;
  active?: boolean;
  notLast?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  className,
  active,
  children,
  notLast,
  ...props
}) => {
  return (
    <button
      type="button"
      className={classNames(
        styles.btn,
        { [styles.active]: active },
        { [styles.notLast]: notLast },
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export { ActionButton };
